var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.0006V10.071C3 9.40226 3.3342 8.77779 3.8906 8.40686L10.8906 3.7402C11.5624 3.29233 12.4376 3.29233 13.1094 3.7402L20.1094 8.40686C20.6658 8.77779 21 9.40226 21 10.071V19.0006M3 19.0006C3 20.1052 3.89543 21.0006 5 21.0006H19C20.1046 21.0006 21 20.1052 21 19.0006M3 19.0006L9.75 14.5006M21 19.0006L14.25 14.5006M3 10.0006L9.75 14.5006M21 10.0006L14.25 14.5006M14.25 14.5006L13.1094 15.261C12.4376 15.7089 11.5624 15.7089 10.8906 15.261L9.75 14.5006",
    stroke: "#9A9A9A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmStep);
export default __webpack_public_path__ + "static/media/confirmStep.8203e3a2bf3df7502ebfcb9e3efa72eb.svg";
export { ForwardRef as ReactComponent };